
export const Routes = {
    // pages
    Default: {
        path: "/"
    },
    Login: {
        path: "/login"
    },
    VerifyMfa: {
        path: "/verify-mfa"
    },

    ForgotPassword: {
        path: "/forgot-password"
    },
    ResetPassword: {
        path: "/reset-password"
    },
    CreatePassword: {
        path: "/create-password"
    },
    Home: {
        path: "/home"
    },
    Order: {
        path: "/orders"
    },

    OrderDetailPage: {
        path: "/orders/:orderId"
    },
    TaxOrderEditor: {
        path: "/orders/taxCertEditor/:orderId"
    },
    TaxOrderNationalEditor: {
        path: "/orders/national/taxCertEditor/:orderId"
    },
    HoaOrderEditor: {
        path: "/orders/hoaFullEditor/:orderId"
    },

    HoaContactEditor: {
        path: "/orders/hoaContactEditor/:orderId"
    },

    Users: {
        path: "/users"
    },

    UpdateUser: {
        path: "/users/:userId"
    },
    CreateUser: {
        path: "/users/create"
    },

    Roles: {
        path: "/roles"
    },

    CreateRole: {
        path: "/roles/create"
    },

    UpdateRole: {
        path: "/roles/:roleId"
    },

    Teams: {
        path: "/teams"
    },

    CreateTeam: {
        path: "/teams/create"
    },

    TeamDetailPage: {
        path: "/teams/:teamId"
    },

    Customers: {
        path: "/customers"
    },
    CreateCustomer: {
        path: "/customers/create"
    },
    CustomerDetailPage: {
        path: "/customers/:customerId"
    },
    BranchDetailPage: {
        path: "/customers/:customerId/:branchId"
    },

    SystemProperties: {
        path: "/system-properties"
    },

    UpdateSystemProperties: {
        path: "/system-properties/:systemPropertyId"
    },
    CreateSystemProperties: {
        path: "/system-properties/create"
    },
    CannedNotes: {
        path: "/canned-notes"
    },
    CreateCannedNotes: {
        path: "/canned-note/create"
    },
    Collector: {
        path: "/collectors"
    },

    CollectorDetailPage: {
        path: "/collectors/:collectorId"
    },
    CreateCollector: {
        path: "/collectors/create"
    },

    UpdateCannedNote: {
        path: "/canned-notes/:noteId"
    },


    Counties: {
        path: "/counties"
    },

    CreateCounty: {
        path: "/counties/create"
    },

    Jurisdiction: {
        path: "/jurisdictions"
    },
    UpdateJurisdiction: {
        path: "/jurisdictions/:jurisdictionId"
    },
    createJurisdiction: {
        path: "/jurisdictions/create"
    },
    StateCode: {
        path: "/state-codes"
    },
    UpdateStateCode: {
        path: "/state-codes/:codeId"
    },
    CreateStateCodes: {
        path: "/state-codes/create"
    },
    Subdivision: {
        path: "/subdivisions"
    },
    UpdateSubDivision: {
        path: "/subdivisions/:subdivisionId"
    },
    CreateSubDivision: {
        path: "/subdivisions/create"
    },
    ReportHistory: {
        path: "/report-history"
    },
    OrderEvents: {
        path: "/order-events"
    },
    UpdateCounty: {
        path: "/counties/:countyId"
    },

    MetroAreas: {
        path: "/metro-areas"
    },
    CreateMetroArea: {
        path: "/metro-areas/create"
    },

    UpdateMetroArea: {
        path: "/metro-areas/:metroAreaId"
    },

    CannedFileNames: {
        path: "/canned-file-names"
    },

    UpdateCannedFileNames: {
        path: "/canned-file-names/:cannedFileNameId"
    },

    CreateCannedFileNames: {
        path: "/canned-file-names/create"
    },

    CannedInvoiceLines: {
        path: "/canned-invoice-lines"
    },

    UpdateCannedInvoiceLine: {
        path: "/canned-invoice-lines/:cannedInvoiceLineId"
    },

    CreateCannedInvoiceLine: {
        path: "/canned-invoice-lines/create"
    },

    PlatformPricing: {
        path: "/accounting/platform-pricing"
    },

    CreatePlatformPricing: {
        path: "/accounting/platform-pricing/create"
    },

    UpdatePlatformPricing: {
        path: "/accounting/platform-pricing/:platFormId"
    },

    TenantPricing: {
        path: "/accounting/tenant-pricing"
    },

    CreateTenantPricing: {
        path: "/accounting/tenant-pricing/create"
    },

    UpdateTenantPricing: {
        path: "/accounting/tenant-pricing/:tenantPricingId"
    },

    PartnerPricing: {
        path: "/accounting/partner-pricing"
    },

    RevenueEvents: {
        path: "/revenue-events"
    },

    CreatePartnerPricing: {
        path: "/accounting/partner-pricing/create"
    },

    UpdatePartnerPricing: {
        path: "/accounting/partner-pricing/:partnerPricingId"
    },

    VendorPricing: {
        path: "/accounting/vendor-pricing"
    },

    CreateVendorPricing: {
        path: "/accounting/vendor-pricing/create"
    },

    UpdateVendorPricing: {
        path: "/accounting/vendor-pricing/:vendorPricingId"
    },

    Profile: {
        path: "/profile"
    },

    CreateOrder: {
        path: "/orders/create"
    },

    ReOrder: {
        path: "/orders/re-order/:orderId"
    },


    FollowUpTypes: {
        path: "/follow-up-types"
    },

    CreateFollowUpType: {
        path: "/follow-up-types/create"
    },

    UpdateFollowUpType: {
        path: "/follow-up-types/:typeId"
    },

    States: {
        path: "/states"
    },

    CreateState: {
        path: "/states/create"
    },

    UpdateState: {
        path: "/states/:stateId"
    },

    Reporting: {
        path: "/reporting"
    },

    SuccessPage: {
        path: "/success"
    },

    BusinessesTransactionPage: {
        path: "/transaction/businesses"
    },

    IndividualsTransactionPage: {
        path: "/transaction/individuals"
    },

    SimplifileConfig: {
        path: "/simplifile-configs"
    },

    UpdateSimplifileConfig: {
        path: "/simplifile-configs/:configId"
    },

    CreateSimplifileConfig: {
        path: "/simplifile-configs/create"
    },
    AppraisalRolls: {
        path: "/appraisal-rolls"
    },
    UpdateAppraisalRolls: {
        path: "/appraisal-rolls/:appraisalRollId"
    },
    BillRelease: {
        path: "/bill-release"
    },
    ExternalBillRelease: {
        path: "/external/bill-releases"
    },
    CreateBillRelease: {
        path: "/bill-release/create"
    },
    UpdateBillRelease: {
        path: "/bill-release/:billReleaseId"
    },

    LinkedAccount: {
        path: "/linked-accounts"
    },
    UpdateLinkedAccount: {
        path: "/linked-accounts/:linkedId"
    },
    CreateLinkedAccount: {
        path: "/linked-accounts/create"
    },
    VerifiedHighRiskAccount: {
        path: "/verified-high-risk-accounts"
    },
    TaxRoll: {
        path: "/tax-rolls"
    },
    UpdateTaxRoll: {
        path: "/tax-rolls/:rollId"
    },
    HighRiskAccount: {
        path: "/high-risk-accounts"
    },
    TaxRoundingConfig: {
        path: "/tax-rounding-config"
    },
    CreateTaxRoundingConfig: {
        path: "/tax-rounding-config/create"
    },
    UpdateTaxRoundingConfig: {
        path: "/tax-rounding-config/:roundConfigId"
    },
    CollectorLink: {
        path: "/collector-links"
    },
    UpdateCollectorLink: {
        path: "/collector-links/:collectorId"
    },
    CreateCollectorLink: {
        path: "/collector-links/create"
    },
    Report: {
        path: "/turn-around-report"
    },
    Association: {
        path: "/associations"
    },
    UpdateAssociation: {
        path: "/associations/:associationId"
    },
    CreateAssociation: {
        path: "/associations/create"
    },
    ManagementCompany: {
        path: "/management-companies"
    },
    UpdateManagementCompany: {
        path: "/management-companies/:companyId"
    },
    CreateManagementCompany: {
        path: "/management-companies/create"
    },
    AutoHoa: {
        path: "/auto-hoa"
    },
    UpdateAutoHoa: {
        path: "/auto-hoa/:hoaId"
    },
    CreateAutoHoa: {
        path: "/auto-hoa/create"
    },
    SortFeeType: {
        path: "/hoa-fee-types"
    },
    ThirdPartyProvider: {
        path: "/third-party-providers"
    },
    UpdateThirdPartyProvider: {
        path: "/third-party-providers/:providerId"
    },
    CreateThirdPartyProvider: {
        path: "/third-party-providers/create"
    },
    ImportVersion: {
        path: "/import-versions"
    },
    QCLogics: {
        path: "/qc-logics"
    },
    UpdateQcLogic: {
        path: "/qc-logics/:qcLogicId"
    },
    CreateQcLogic: {
        path: "/qc-logics/create"
    },
    NoteLogics: {
        path: "/note-logics"
    },
    CreateNoteLogics: {
        path: "/note-logics/create"
    },
    UpdateNoteLogics: {
        path: "/note-logics/:noteLogicId"
    },
    ScrapperModule: {
        path: "/scrapers-modules"
    },
    CreateScapperMpdule: {
        path: "/scrapers-modules/create"
    },
    UpdateScapperMpdule: {
        path: "/scrapers-modules/:moduleId"
    },
    RecordAudit: {
        path: "/record-audit"
    },
    UpdateRecordAudit: {
        path: "/record-audit/:auditId"
    },
    ErrorLogs: {
        path: "/error-logs"
    },
    RegisteredScrapper: {
        path: "/registered-scrapers"
    },
    Codes: {
        path: "/codes"
    },
    UpdateCodes: {
        path: "/codes/:codeId"
    },
    CreateCodes: {
        path: "/codes/create"
    },
    // AccountTranslations:{
    //     path:"/account-translations"
    // },
    Tenants: {
        path: "/tenants"
    },
    UpdateTenants: {
        path: "/tenant/:tenantId"
    },
    Payment: {
        path: "/payments"
    },
    TurnAroundReport: {
        path: "/turn-around-report"
    },
    CountyReport: {
        path: "/county-report"
    },
    RevenueReport: {
        path: "/revenue-report"
    },
    AggregateUserEfficiencyReport: {
        path: "/aggregate-user-efficiency-report"
    },
    DetailedUserEfficiencyReport: {
        path: "/detailed-user-efficiency-report"
    },
    AutoVsManualReport: {
        path: "/auto-vs-manual-report"
    },
    AccountsReceivableReport: {
        path: "/accounts-receivable-report"
    },
    FulfillmentCandidateReport: {
        path: "/fulfillment-candidate-report?"
    },
    FullfillmentCustomerReportApiQuery: {
        path: "/fulfillment-customer-report"
    },
    DailyOrderCountReport: {
        path: "/daily-order-count-report"
    },
    ProductAssignmentReport: {
        path: "/product-assignment-report"
    },
    Transactions: {
        path: "/fnf-transactions"
    },
    Accounting: {
        path: "/accounting"
    },
    AccountTranslations: {
        path: "/account-translations"
    },
    UpdateAccountTranslations: {
        path: "/account-translations/:accountId"
    },
    CreateAccountTranslations: {
        path: "/account-translations/create"
    }
}